import Header from "./components/header"
import Slider from "./components/slider"
import Accordion from "./components/accordion";
import BlueInfoBanner from "./components/blueInfoBanner";
import Anchors from "./components/anchors";
import Sticky from "./components/sticky";
import Sharer from "./components/sharer";
import Campagne from "./components/campagne";
import Select from "./components/select";
import Filters from "./components/filters";
import Pagination from "./components/pagination";
import Panier from "./components/panier";
import Form from "./components/form";
import DonationShare from "./components/donationShare";
import Grid from "./components/grid";
import AnchorsHash from "./components/anchorsHash";
import PopinManager from "./components/popinManage";
import Tracking from "./components/tracking";
import GatedContent from "./components/gatedContent";
import DatePicker from "./components/datePicker";
import IfiCalculator from "./components/ifiCalculator";

const main = {
    init: function() {
        Tracking.init();
        Header.init();
        Sticky.init();
        Slider.init();
        PopinManager.init();
        Accordion.init();
        BlueInfoBanner.init();
        Anchors.init();
        Sharer.init();
        Campagne.init();
        Filters.init();
        Select.init();
        Pagination.init();
        Panier.init();
        Form.init();
        DonationShare.init();
        Grid.init();
        AnchorsHash.init();
        GatedContent.init();
        DatePicker.init();
        IfiCalculator.init();
    }
}

export default main